import React, { useState, useEffect, useRef, useCallback } from 'react';
import style from './NoticeBoradSlideDetail.module.css';
import HeadSub from '../../../../components/comm/HeadSub';

import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import ToastPopup from '../../../../components/comm/ToastPopup';
import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';

import LocationImageView from '../../../../components/box/LocationImageView';
import { SERVER_URL } from '../../../../constants/url';
import { useLocation } from 'react-router-dom';


const NoticeBoradSlideDetail = () => {

    const user = JSON.parse(sessionStorage.getItem("loginUser"));

    const location = useLocation();
    const { state } = location;

    const [showFullImage, setShowFullImage] = useState(false);
    const [saveImgUrl, setSaveImgUrl] = useState('');


    // 이미지 크게 보기 핸들러
    const handleViewFullImage = (imgUrl) => {
        setSaveImgUrl(imgUrl);
        setShowFullImage(true);
    };
    const handleCloseFullImage = () => {
        setShowFullImage(false);
    };

    // 로컬 기준 98 파일  103 url
    //const cntsNttId = state?.cntsNttId ?? null;

    const [ searchNtt, setSearchNtt ] = useState({
        cntsNttId: state?.cntsNttId ?? null
        , usrInfoId: user?.usrInfoId ?? null
        , cntsSndngHistId: state?.idx ?? null
        , cnfrmAt: state?.cnfrmAt ?? null
    });

    // toast
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const [srcList, setSrcList] = useState([])

    const [contentsInfo, setContentsInfo] = useState({
        cntsSj : "",
        cntsCn : "",
        rgstMthdCd : "",
        cntsUrl : ""
    });

    const [src, setSrc] = useState("");
    const [slideNaviHide, setSlideNaviHide] = useState("");


    useEffect(() => {
        if(!searchNtt?.cntsNttId) {
            setToastMessage('잘못 된 접근입니다.');
            setToast(true);
            return;
        }
        getContentsInfo();
    },[searchNtt?.cntsNttId])

    const getContentsInfo = useCallback(async () => {

        console.log( " ===========> getContentsInfo : ", searchNtt );

        const url = "/homecare/guide/retrieveContentsInfo";

        const jToken = localStorage.getItem('jToken');

        const reqOptions = {
            headers: {
                'Authorization': 'Bearer ' + jToken,
            }
        }

        await axiosApi.post(url, {...searchNtt }, reqOptions)
        .then((res) => {
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                const contInfo = res.data.result.contInfo;

                const filse = contInfo.fileList;

                if(contInfo.rgstMthdCd === 'U') {
                    setSrc(contInfo.cntsUrl);
                } else if(contInfo.rgstMthdCd === 'F' && filse.length === 0) {
                    setSlideNaviHide(true);
                    setToastMessage('첨부된 파일이 없습니다.');
                    setToast(true);
                    return;
                } else {
                    const urls = filse.map((item) => {
                        return `${SERVER_URL}/cmm/fms/getImage?atchFileStr=${item.atchFileStr}&fileSn=${item.fileSn}`;
                    });
                    setSlideNaviHide(false);
                    setSrcList(urls);
                    
                }
debugger;
                setContentsInfo(contInfo);

            } else {
                setToastMessage(res.data.resultMessage);
                setToast(true);
            }
        })
        .catch(err => {
        })

    }, [searchNtt]);

    // if(!cntsNttId) return null;

    return (
        <>
            <HeadSub title="상세 보기" />

            <div id="sub-content" data-layout="white" style={{overflowX:'hidden'}}>
                <div className="inner-wrap" data-pad="normal">

                <strong className={style['title']}>{contentsInfo.cntsSj}</strong>

                {contentsInfo.rgstMthdCd === 'U' &&
                    <div className={style['slide-wrap']}>
                        <div className={style['slide-frame']}>
                            <iframe
                                width="600"
                                height="621"
                                src={src}
                                frameborder="0"
                                referrerpolicy="strict-origin-when-cross-origin"
                                allowfullscreen>
                            </iframe>
                        </div>
                    </div>
                }

                {contentsInfo.rgstMthdCd !== 'U' &&
                    <div className={style['position-box']}>
                        <div className={style['swiper-wrap-box']}>
                            <Swiper
                                pagination={{
                                    el: '.side-fractions',
                                    type: 'custom',
                                    renderCustom: function (swiper, current, total) {
                                        return  (
                                            ((current < 10) ? ('0' + current) : current)
                                            + ' / ' +
                                            (((total) < 10) ? ('0' + (total)) : (total))
                                        );
                                    }
                                }}
                                modules={[Navigation, Pagination]}
                                navigation={{
                                    nextEl: '.swiper-button-next', // 다음 버튼
                                    prevEl: '.swiper-button-prev', // 이전 버튼
                                }}
                                >
                                {
                                    srcList.length > 0 && srcList.map((item, index) => (
                                        <SwiperSlide key={index}>
                                        <div className="img-box">
                                            {/* 🔹 이미지 클릭 시 확대보기 */}
                                            <img
                                            src={item}
                                            alt=""
                                            onClick={() => handleViewFullImage(item)}
                                            style={{ cursor: 'pointer' }}
                                            />
                                        </div>
                                        </SwiperSlide>
                                    ))


                                    // srcList.length > 0 && srcList.map((item) => {
                                    //     return (
                                    //         <SwiperSlide>
                                    //             <div className='img-box'>
                                    //                 <img src={item} alt="" />
                                    //             </div>
                                    //         </SwiperSlide>
                                    //     )
                                    // })
                                }
                            </Swiper>

                            {!slideNaviHide && (
                                <div className={style['navi-box']}>
                                    <div className='swiper-button-prev'>
                                        <button className={`${style.slideBtn} ${style.prevBtn}`}></button>
                                    </div>
                                        <p className='side-fractions'></p>
                                    <div className='swiper-button-next'>
                                        <button className={`${style.slideBtn} ${style.nextBtn}`}></button>
                                    </div>
                                </div>
                            )}    
                            

                        </div>
                    </div>
                }
                </div>
            </div>
            {toast && (
                <ToastPopup
                    setToast={setToast}
                    position="center"
                    message={toastMessage}
                />
            )}

            {showFullImage && (
            <LocationImageView
              imgUrl={saveImgUrl}
              visible={showFullImage}
              onClose={handleCloseFullImage}
            />
          )}
        </>
    );
};

export default NoticeBoradSlideDetail;
